import { Injectable } from '@angular/core';
import _forEach from 'lodash-es/forEach';

export interface ICompleteNumberLabels {
    one?: string;
    none?: string;
    default: string;
}

type TReplacements = string | { [key: string]: string | number };

@Injectable()
export class LabelService {
    /**
     * Used to Complete a Yii.t() string
     * replace %placeholder% replacements argument
     * or replace keys given n replacements argument
     * @param {string} stringToComplete
     * Yii can(must) be used here
     * @param {string} replacements
     * 2 types can be used:
     * string : in this case, you MUST use %placeholder% as var name in "stringToComplete"
     * {[key: string]: string} : in this case you can use whatever you want as var name
     * ex : completeLabel( Yii.('catName', 'hello Mister %foo% %bar%') , {foo:'John', bar:'Doe'} )
     * @return {string}
     */
    public completeLabel(stringToComplete: string, replacements: TReplacements): string {
        if (typeof replacements === "string") {
            return stringToComplete.replace('%placeholder%', replacements);
        } else {
            let str: string = stringToComplete;
            _forEach(replacements, (replacement: string, key: string) => {
                str = str.replace(`%${key}%`, replacement);
            });
            return str;
        }
    }

    /**
     * Generates labels depending on the numerical value, replacing %placeholder% by the given value.
     * You can use labels for 0, 1 and other values.
     * If strings for 0 or 1 are not provided, the default label will be used.
     *
     * @param value a number to use as a placeholder in the labels
     * @param labels labels to use, depending on the value
     */
    public completeNumber(value: number, labels: ICompleteNumberLabels): string {
        if (value === 0 && labels.none !== undefined) {
            return this.completeLabel(labels.none, `${value}`);
        }

        if (value === 1 && labels.one !== undefined) {
            return this.completeLabel(labels.one, `${value}`);
        }

        return this.completeLabel(labels.default, `${value}`);
    }
}
